import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { from, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(private readonly kc: KeycloakService) {}

  login(authMethod: string) {
    if (this.isUserLoggedIn()) {
      this.kc.updateToken();
    } else {
      return from(this.kc.login({ action: 'login' }));
    }
  }

  logout(): Observable<void> {
    return from(this.kc.logout());
  }

  isUserLoggedIn(): boolean {
    return this.kc.isLoggedIn();
  }

  getUserId(): string {
    return this.kc.getKeycloakInstance().subject;
  }
}
